import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockBack = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.6667 7.00002C11.6667 4.42269 9.57737 2.33335 7.00004 2.33335C5.53176 2.33335 4.24157 3.01206 3.39373 4.07939L4.37333 4.07652L4.37675 5.24318L1.45837 5.25173L1.45838 2.33335H2.62504L2.62504 3.17888C3.68236 1.94857 5.23664 1.16669 7.00004 1.16669C10.2217 1.16669 12.8334 3.77836 12.8334 7.00002C12.8334 10.2217 10.2217 12.8334 7.00004 12.8334C4.70407 12.8334 2.76262 11.5079 1.81099 9.59296L2.85576 9.07375C3.62228 10.6162 5.17334 11.6667 7.00004 11.6667C9.57737 11.6667 11.6667 9.57735 11.6667 7.00002Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.41663 4.08331H7.58329V6.75836L8.5791 7.75417L7.75415 8.57912L6.41663 7.2416V4.08331Z",
		fill: "currentColor"
	})]
});
export default SvgClockBack;
